const TRANSACTION_TYPES = require('./transactionTypes');
const UAM_GRANULAR_PERMISSIONS = require('./uamGranularPermissions');
const APPROVAL_QUEUE = require('./approvalQueue');
const ENVIRONMENT_HEADER = require('./environmentHeader');

module.exports = {
  TRANSACTION_TYPES,
  UAM_GRANULAR_PERMISSIONS,
  APPROVAL_QUEUE,
  ...ENVIRONMENT_HEADER,
};
